import React, { useEffect, useState, useRef, useContext, useMemo } from 'react';
import { debounce } from 'lodash';
import * as XLSX from 'xlsx';
import APIService from '@shared/services/api';
import Notify from '@shared/notify';
import TextInput from '@shared/component/TextInput';
import moment from 'moment';
import List from '@shared/component/List';
import { AuthContext } from '@shared/context/AuthContext';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import CheckValidator from '@shared/checkValidator';
import Lists from '@shared/component/Lists';
import { ActionValues, actionsPermissionValidator } from '@utils/static/commonUtils';
import CustomDateTimePicker from '@shared/component/DatePicker';
import MultiSelect from '@shared/component/MultiSelect';
interface FormData {
    name?: null;
    // Add more fields as needed
}
export function OtherReport() {
    const min = new Date('2023-01-09');
    const currentDate = new Date();
    const [errors, setError] = useState<any>({
        name: {
            required: true,
            error: true,
            message: 'Please enter name',
            pattern: /^[A-Za-z][A-Za-z0-9\s.&]*$/, ///^[A-Za-z0-9\s]*$/,
            maxLength: 50,
        },
        categoryId: {
            required: true,
            error: true,
            message: 'Please select category',
        },
    });
    const listRef: any = useRef(null);
    const { setLoader } = useContext(AuthContext);
    const [categories, setCategories] = useState([]);
    const [report, setReport] = useState({
        startDate: null,
        endDate: null,
        categoryId: {},
        itemId: {},
    });
    const itemRef: any = useRef(null);
    const [id, setId] = useState(null);
    const [items, setitems] = useState([]);
    const [temp, setTemp] = useState([]);
    const [disable, setDisable] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);
    const [demand, setDemnad] = useState([]);
    const [recordCount, setRecordCount] = useState(0);
    const [formData, setFormData] = useState<any>({ name: null });
    const [showList, setShowList] = useState(false);
    const [edit, setEdit] = useState(false);

    const [columns, setColumns] = useState({
        demandOthersId: 'Demand ID',
        'app_user.name': 'Vendor Name',
        'app_user.phone': 'Number',
        deliveryStatus: 'Status',
        'demands_other.category.name': 'Category',
        'demands_other.item.name': 'Item',
        deliveredDeliveryDate: 'Actual Delivery Date',
        'demands_other.quantity': 'Quantity',
        'demands_other.itemUnit': 'Unit',
        rate: 'Bid Amount (Rs.)',
        'demands_other.createdAt': 'Created Date',
    });

    const getCategory = async () => {
        try {
            setLoader(true);
            const apiUrl = `category/all/nolimit`;
            const data = await APIService.getAll(apiUrl, true, false);
            setLoader(false);
            setCategories(data.data.data);
        } catch (err) {
            setLoader(false);
        }
    };

    const searchCategory = async (value: any, page: any = 1) => {
        try {
            const checkData: any = {};

            if (report?.categoryId?.value) {
                checkData.categoryId = report?.categoryId?.value;
            }

            const start = moment(report.startDate).format('YYYY-MM-DD');
            const end = moment(report.endDate).format('YYYY-MM-DD');
            if (report?.itemId?.length > 0) {
                const items = report.itemId.map(obj => obj.id);
                checkData['itemId'] = JSON.stringify(items);
                // categoryId=${checkData.categoryId}&itemId=${checkData.itemId}
            }

            //if (demand?.length > 0) {
            const data = await APIService.getAll(
                `report/search/oth?page=${page}&order=desc&startDate=${start}&endDate=${end}&search=${value}&categoryId=${checkData.categoryId}&itemId=${checkData.itemId}`,
                true,
                false,
            );

            setDemnad(data.data.data);
            setRecordCount(data?.data?.count || 0);
            // } else {
            //     setDemnad([]);
            // }
        } catch (err) {
            setLoader(false);
        }
    };

    useEffect(() => {
        getCategory();
    }, []);

    const getValue = (e: any, dateType: string) => {
        try {
            if (!e) {
                setitems([]);

                itemRef.current.clearDropdown();
                const data = { ...report, itemId: {}, categoryId: {} };
                setReport(data);
                return;
            }
            const data = { ...report, [dateType]: e };
            setReport(data);
        } catch (error) {}
    };

    const handleExport = () => {
        try {
            const element = document.getElementById('excel-table');
            const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

            /* generate workbook and add the worksheet */
            const wb: XLSX.WorkBook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

            /* save to file */

            XLSX.writeFile(wb, 'exported_data.xlsx');
        } catch (error) {}
    };

    const GetFinalizedDemand = async (get: any = 1) => {
        try {
            if (report.startDate == null) {
                Notify('error', 'Please choose start date');
                return;
            }
            if (report.endDate == '' || report.endDate == null) {
                Notify('error', 'Please choose end date');
                return;
            }

            const start = moment(report.startDate).format('YYYY-MM-DD');
            const end = moment(report.endDate).format('YYYY-MM-DD');

            if (start > end) {
                Notify('error', 'Please select end date grater than the Start date');
                return;
            }
            const data: any = {
                startDate: start,
                endDate: end,
                categoryId: report?.categoryId?.value,
            };

            if (report.itemId.length >= 1) {
                const items = report.itemId.map(obj => obj.id);
                data.itemId = items;
            }

            setLoader(true);
            const queryString = `page=${get}&sort=createdAt`;
            const url = `report/other?${queryString}`;
            const updateddata = await APIService.post(url, data, true, true);

            if (updateddata.status === 200) {
                setDemnad(updateddata.data.data);
                setRecordCount(updateddata?.data?.count || 0);
                setLoader(false);
                setShowList(true);
                listRef.current.clearSearchBox(true);
            }
        } catch (error) {
            setLoader(false);
        }
    };

    return (
        <div className="container dash-container">
            <div className="dash_bread_box">
                <ul>
                    <li>Vendor Report</li>
                </ul>
            </div>

            <div className="content_body_cover">
                <div className="row">
                    <div className="col-sm-2">
                        <div className="form-floating">
                            <CustomDateTimePicker
                                data={{
                                    name: 'startDate',
                                    placeholder: 'Select Date',
                                    label: 'Start Date',
                                    type: 'datetime-local',
                                    id: 'floatingInput',
                                }}
                                date={min}
                                minDate={min}
                                maxDate={currentDate}
                                controlName="startDate"
                                isSubmit={isSubmit}
                                value={report.startDate}
                                setValue={(e: any) => getValue(e?.startDate, 'startDate')}
                                // errorMsg={errors?.cutOffTime.message}
                                inputProps={errors}
                                showTimeSelect={false}
                            />
                        </div>
                    </div>
                    <div className="col-sm-2">
                        <div className="form-floating">
                            <CustomDateTimePicker
                                data={{
                                    name: 'endDate',
                                    placeholder: 'Select Date',
                                    label: 'End Date',
                                    type: 'datetime-local',
                                    id: 'floatingInput',
                                }}
                                date={min}
                                minDate={min}
                                maxDate={currentDate}
                                controlName="endDate"
                                isSubmit={isSubmit}
                                value={report.endDate}
                                setValue={(e: any) => getValue(e?.endDate, 'endDate')}
                                // errorMsg={errors?.cutOffTime.message}
                                inputProps={errors}
                                showTimeSelect={false}
                            />
                        </div>
                    </div>
                    <div className="col-sm-3">
                        <MultiSelect
                            isSingle={true}
                            options={categories}
                            placeholder={'Select Category'}
                            getMultiSelectValue={(e: any) => {
                                getValue(e, 'categoryId');
                                if (e) {
                                    const check = categories.find((category: any) => category.id === e.value);
                                    setitems(check?.items || []);
                                    errors['categoryId']['error'] = false;
                                    setError(errors);
                                } else {
                                    errors['categoryId']['error'] = true;
                                    setError(errors);
                                }
                            }}
                            displayName="name"
                            displayValue="id"
                            isClearable={edit ? false : true}
                            setSelectedValues={null}
                        />

                        {errors?.categoryId?.required && errors?.categoryId?.error && isSubmit && (
                            <div className="text-danger ft-12 error-msg"> {errors?.categoryId.message}</div>
                        )}
                    </div>
                    <div className="col-sm-3">
                        <MultiSelect
                            ref={itemRef}
                            // isSingle={true}
                            options={items}
                            placeholder={'Select Items'}
                            getMultiSelectValue={(e: any) => {
                                getValue(e, 'itemId');
                            }}
                            displayName="name"
                            displayValue="id"
                            isClearable={edit ? false : true}
                            setSelectedValues={null}
                        />

                        {errors?.categoryId?.required && errors?.categoryId?.error && isSubmit && (
                            <div className="text-danger ft-12 error-msg"> {errors?.categoryId.message}</div>
                        )}
                    </div>
                    <div className="col-sm-2">
                        <Button
                            variant="secondary"
                            className="full_width_btn btn dark_btn custom_btn"
                            onClick={() => GetFinalizedDemand()}
                        >
                            Search
                        </Button>
                    </div>
                </div>
                <br></br>
                <br></br>
                {showList && (
                    <Lists
                        handleExport={handleExport}
                        ref={listRef}
                        headers={columns}
                        data={demand}
                        searchItem={searchCategory}
                        type={'report'}
                        recordCount={recordCount}
                        callPagination={GetFinalizedDemand}
                        helperText={'Search By Vendor Name, Number, Status, Category, Item'}
                    />
                )}
            </div>
        </div>
    );
}
